import { useState, type FormEvent } from 'react';
import { Card } from '@/components/ui/card';
import WorkHistoryTimeline from './WorkHistoryTimeline';
import PositionHistoryTimeline from './PositionHistoryTimeline';

export default function WorkerHistoryPage() {
  const [mode, setMode] = useState<'worker' | 'position'>('worker');
  const [input, setInput] = useState('');
  const [query, setQuery] = useState<string | null>(null);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    setQuery(input.trim() || null);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <div>
        <h1 className="font-serif text-3xl text-heritage-blue">Worker &amp; Position History</h1>
        <p className="text-sm text-slate-500 mt-1">
          Employment periods, seat journeys, vacancy gaps and FTC&#8596;ICA&#8596;PERM transitions.
        </p>
      </div>

      <div className="flex gap-2">
        {(['worker', 'position'] as const).map((m) => (
          <button
            key={m}
            onClick={() => { setMode(m); setQuery(null); setInput(''); }}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium ring-1 ${
              mode === m ? 'bg-heritage-blue text-white ring-heritage-blue' : 'bg-white text-slate-600 ring-slate-200'
            }`}
          >
            {m === 'worker' ? 'By worker' : 'By position'}
          </button>
        ))}
      </div>

      <form onSubmit={submit} className="flex gap-2">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={mode === 'worker' ? 'Employee ID (e.g. 43xxxxx)' : 'F&O Position ID (e.g. 000046)'}
          className="flex-1 rounded-lg ring-1 ring-slate-200 px-3 py-2 text-sm tabular-nums focus:ring-heritage-blue focus:outline-none"
        />
        <button type="submit" className="px-4 py-2 rounded-lg bg-heritage-blue text-white text-sm font-medium hover:bg-heritage-blue/90">
          View history
        </button>
      </form>

      {query && (
        <Card className="p-6">
          {mode === 'worker'
            ? <WorkHistoryTimeline employeeId={query} />
            : <PositionHistoryTimeline foPositionId={query} />}
        </Card>
      )}
    </div>
  );
}
